import "./App.css";
import "../src/components/css/services.css";
import "../src/components/css/why-canvendor.css";
import "../src/components/css/contact-form.css";
import "../src/components/css/insights.css";
import "../src/components/css/footer.css";
import "../src/components/css/location.css";
import "../src/static/css/contact-card.css";
import "../src/static/css/contact.css";
import "../src/static/css/about.css";
import "../src/static/css/resources.css";
import "../src/pages/industries/indus-css/common-industries.css";
import "../src/components/css/home-common.css";
import "../src/components/css/scroll.css";
import "../src/pages/services/service-css/main-services.css";
import "../src/pages/services/service-css/common-for-services.css";
import "../src/pages/career/careers.css";

// import './static/vendor/aos/aos.css'
// import './static/vendor/bootstrap/css/bootstrap.min.css'
// import './static/vendor/boxicons/css/boxicons.min.css'
// import './static/vendor/glightbox/css/glightbox.min.css'
// import './static/vendor/icon/remixicon.css'
// import './static/vendor/swiper/swiper-bundle.min.css'
// import './static/css/style.css'
import NavComponent from "./components/NavComponent";
import { BrowserRouter, Route, Router, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import CloudService from "./pages/services/CloudService";

import Contact from "./pages/Contact";
import Semiconductors from "./pages/industries/Semiconductors";
// import Seminew from './pages/industries/Seminew';
import Manufacturing from "./pages/industries/Manufacturing";
import CommunicationsAndInformation from "./pages/industries/CommunicationsAndInformation";
import CreativeAgencies from "./pages/industries/CreativeAgencies";
import Automotive from "./pages/industries/Automotive";
import BankingAndFinance from "./pages/industries/BankingAndFinance";
import Industries from "./pages/Industries";

import Footer from "./components/Footer";
import ContactCard from "./components/ContactCard";
import History from "./pages/about/History";
// import MissionAndVision from './pages/about/MissionAndVision';
import WhyCanvendor from "./pages/about/WhyCanvendor";

import ScrollToTop from "./components/ScrollToTop";
import AOS from "aos";
import "aos/dist/aos.css";

import EnquriyForm from "./pages/EnquriyForm";
import DigitalService from "./pages/services/DigitalService";
import ItSolution from "./pages/services/ItSolution";
import Enterprise from "./pages/services/Enterprise";
import WebandMobileService from "./pages/services/WebandMobileService";
import InsightPage from "./pages/InsightPage";
import Termsofservice from "./pages/Termsofservice";
import Policy from "./pages/Policy";
import CareerForm from "./pages/career/CareerForm";
import Career from "./pages/career/Career";
import Insurance from "./pages/industries/Insurance";

import { BlogMain } from "./pages/blog/BlogMain";
import { BlogMain2 } from "./pages/blog/BlogMain2";
import { CaseStudiesMain } from "./pages/caseStudies/CaseStudiesMain";
import { CaseStudiesMain2 } from "./pages/caseStudies/CaseStudiesMain2";
import AgenticAI from "./pages/services/AgenticAI";
import PageNotFound from "./components/PageNotFound";
import FleetManagement from "./pages/industries/Transportation & Logistics/FleetManagement";
import AIML_Solution from "./pages/services/AIML_Solution";
import HealthCare from "./pages/industries/HealthCare";
import { BlogMain3 } from "./pages/blog/BlogMain3";
import AimlService from "./pages/services/AimlService";
import Healthcare1 from "./pages/industries/Healthcare1";
import { AgenticAIBlog } from "./pages/blog/AgenticAIBlog";

function App() {
  AOS.init({ duration: 900 });

  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        {/* <NavComponent/> */}
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/about" element={<About />} />
          {/* about */}
          <Route path="/about/history" element={<History />} />
          {/* <Route path='/about/mission&vision' element={<MissionAndVision/>} /> */}
          <Route path="/about/whyCanvendor" element={<WhyCanvendor />} />
          <Route path="/about/careers" element={<Career />} />

          <Route path="/services" element={<Services />} />
          {/* services */}
          {/* <Route path="/services/aiml" element={<AIML_Solution />} /> */}
          <Route path="/services/aiml" element={<AimlService />} />
          <Route path="/services/agenticAI" element={<AgenticAI />} />
          <Route path="/services/cloudSolutions" element={<CloudService />} />
          <Route
            path="/services/digitalTransformation"
            element={<DigitalService />}
          />
          <Route
            path="/services/itConsultingService"
            element={<ItSolution />}
          />
          <Route path="/services/enterpriseService" element={<Enterprise />} />
          <Route
            path="/services/webAppService"
            element={<WebandMobileService />}
          />

          <Route path="/industries" element={<Industries />} />
          <Route
            path="/industries/fleetManagement"
            element={<FleetManagement />}
          />

          <Route path="/industries/manufacturing" element={<Manufacturing />} />
          <Route path="/industries/automotive" element={<Automotive />} />
          <Route
            path="/industries/banking&finance"
            element={<BankingAndFinance />}
          />

          <Route
            path="/industries/communications&information"
            element={<CommunicationsAndInformation />}
          />
          {/* <Route path="/industries/healthcare" element={<HealthCare />} /> */}
          <Route path="/industries/healthcare" element={<Healthcare1 />} />
          <Route path="/industries/insurance" element={<Insurance />} />
          <Route path="/insights" element={<InsightPage />} />
          <Route path="/blog" element={<BlogMain />} />
          <Route path="/blog2" element={<BlogMain2 />} />
          <Route path="/blog/how-agentic-ai-will-transform-healthcare-claims-automation-2026" element={<BlogMain3 />} />
          <Route path="/blog/agentic-ai-automation-qa-realistic-roi" element={<AgenticAIBlog />} />
          <Route path="/casestudies" element={<CaseStudiesMain />} />
          <Route path="/casestudies2" element={<CaseStudiesMain2 />} />
          <Route path="/Terms" element={<Termsofservice />} />
          <Route path="/privacyPolicy" element={<Policy />} />
          {/* <Route path='/resources' element={<Resources/>}/> */}
          {/* resources */}
          {/* <Route path='/resources/blogs' element={<Blogs/>}/> */}
          {/* <Route path='/resources/caseStudies' element={<CaseStudies/>}/> */}
          {/* <Route path='/resources/industryInsights' element={<IndustryInsights/>}/> */}
          {/* <Route path='/resources/faq' element={<Faq/>}/> */}

          <Route path="/contactUs" element={<Contact />} />
          <Route path="/form" element={<CareerForm />} />
          <Route path="/careers" element={<Career />} />
          <Route path="/enquiry" element={<EnquriyForm />} />
          <Route path="/contact/apac/tamilnadu" element={<Contact />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
